import { useEffect } from 'react';
import 'react-toastify/dist/ReactToastify.css';
import { useLocation } from 'react-router-dom';

import { ClientProvider } from '@apono/client-app-sdk';
import { AppRoutes } from '@routes';
import { AnalyticsProvider } from '@common/utils/analytics/Provider';
import FeatureFlagsProvider from '@common/utils/flags/Provider';
import { useAxiosInterceptors } from '@common/utils/axios-config';
import { SmokeTestsWrapper } from '@common/utils/smoke-testing/SmokeTestWrapper';
import SentryWrapper from '@common/utils/SentryWrapper';
import { useAponoAuth } from '@common/ui/Authenticated';

export function App() {
  const { accessToken } = useAponoAuth();
  const { pathname, search } = useLocation();
  const { handleResponseSuccess, handleResponseError } = useAxiosInterceptors();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname, search]);

  return (
    <ClientProvider
      accessToken={accessToken}
      basePath={window.location.protocol + '//' + window.location.host}
      axiosInterceptorSuccess={handleResponseSuccess}
      axiosInterceptorError={handleResponseError}
    >
      <SentryWrapper>
        <FeatureFlagsProvider>
          <AnalyticsProvider>
            <SmokeTestsWrapper>
              <AppRoutes />
            </SmokeTestsWrapper>
          </AnalyticsProvider>
        </FeatureFlagsProvider>
      </SentryWrapper>
    </ClientProvider>
  );
}
